import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import reportWebVitals from './reportWebVitals';
import MembersAreaService from './services/MemberArea.service';
import ErrorBoundary from './components/ErrorBoundary.component';

// const link = document.createElement('link');
// link.rel = 'stylesheet';
// // link.type = 'text/css';
// link.href =  process.env.NODE_ENV === 'development' ? `http://localhost:3001/members/school/style/${window.location.hostname}` : `//${window.location.host}/theme.ecss`

// link.onload = () => {
//   console.log('CSS carregado com sucesso');
// }

// link.onerror = () => {
//   console.error('Erro ao carregar o CSS');
// }

// document.head.appendChild(link);


window.dataLayer = window.dataLayer || [];
function gtag(){window.dataLayer.push(arguments);}
window.gtag = gtag;
gtag('js', new Date());


const renderApp = () => {
  ReactDOM.render(
    <React.StrictMode>
      <ErrorBoundary>
        <App />
      </ErrorBoundary>
    </React.StrictMode>,
    document.getElementById('root')
  );
}

// The app must mount regardless of what this fetch does: a hostname without a matching
// school, a backend hiccup, or a malformed/empty response used to leave the page blank
// forever (nothing ever called ReactDOM.render), which is indistinguishable from a crash.
new MembersAreaService().get(`school/metadata/${window.location.hostname}`).then((response) => {
  const metadata = (response && typeof response === 'object' && !Array.isArray(response)) ? response : {}

  window.localStorage.setItem('metadata', JSON.stringify({...metadata, school_id: metadata?._id}))

  if(metadata.name){
    document.title = `${metadata.name} - Área de membros`
  }
}).catch((e) => {
  console.log('Failed to load school metadata', e)
}).finally(() => {
  renderApp()
})

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();



